<template>
  <div class="main-wrapper" ref="wrapper">
    <Navbar />
    <!-- <transition name="fade"> -->
    <router-view class="main-content" />
    <!-- </transition> -->
    <Footer class="footer" />
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Bubble from "@/components/Bubble.vue";

export default {
  metaInfo: {
    // noscript: [{ innerHTML: "Diese Webseite benötigt JavaScript." }],
    title: "DachauDenktWeiter",
    titleTemplate: "%s | DachauDenktWeiter",
    meta: [
      // {
      // name: "description"
      // content:
      //   "Wie soll sich Dachau in den kommenden Jahrzehnten entwickeln? Um Antworten auf diese Fragen zu finden, entwirft die Stadt Dachau ein räumliches Leitbild. Machen Sie mit! Denn es ist Ihre Stadt, Ihre Heimat, Ihre Zukunft."
      // },
      {
        name: "keywords",
        content:
          "dachau, denkt, weiter, beteiligung, plattform, mach, mit, interaktiv, karte"
      }
    ]
  },
  components: {
    Navbar,
    Footer,
    Bubble
  },
  data() {
    return {
      height: document.body.clientHeight
    };
  }
  // created() {
  //   console.log(process.env.VUE_APP_API_URL);
  // }
};
</script>
<style lang="scss">
$font-primary: Arial, "sans-serif";
$bg-color1: #b8c2d6;
$bg-color2: #9db0ca;
$bg-color3: #b3db11;
$font-color1: #093f7f;

* {
  font-family: $font-primary;
  font-size: 1em;
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
html {
  font-family: $font-primary;
  background-color: $bg-color1;
}
body {
  padding-left: 5px;
  padding-right: 5px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.main-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-content {
  flex: 1 0 auto;
}

.footer {
  flex-shrink: 0;
}

@media (min-width: 1200px) {
  body {
    padding: 0px;
    overflow-y: scroll;
  }
}

//Globale Klassen
.primary-color {
  color: $font-color1;
}

.primary-bg-color {
  background-color: $font-color1;
}

.bg-green {
  background-color: rgb(186, 228, 70);
}
//Grid System
.row {
  display: flex;
  flex-direction: column;
  & > div {
    margin: 15px;
  }
  .col-push {
    flex: 0;
    margin: 0;
  }
}
@media (min-width: 768px) {
  .row {
    flex-direction: row;
    & > div {
      margin: 20px;
    }
    .col-push {
      flex: 1;
      margin: 20px;
    }
    .col {
      flex: 1;
    }
    .col-3 {
      flex: 2.5;
    }
    .col-3-center {
      flex: 2.5;
      > * {
        width: 70%;
      }
    }
  }
}

// Globale Styles

// Leaflet Popup
.leaflet-popup-content-wrapper {
  box-shadow: 3px 3px 5px rgba(134, 134, 134, 0.493) !important;
  // background: rgba(255, 255, 255, 0.5) !important;
  border-radius: 0 !important;
}
.leaflet-popup-content {
  width: auto !important;
  height: auto !important;
  padding: 0px;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.leaflet-popup-tip {
  // background: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 3px 3px 5px rgba(134, 134, 134, 0.493) !important;
}
.leaflet-popup-close-button {
  color: rgb(78, 78, 78) !important;
}
@media (min-width: 1200px) {
  .leaflet-popup-content {
    padding: 10px;
  }
}
form {
  & > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    input {
      max-width: 100%;
      display: inline-block;
    }
    label {
      display: none;
    }
  }
}
@media (min-width: 576px) {
  form {
    & > div {
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      input {
        display: inline-block;
        &::placeholder {
          // visibility: hidden;
        }
      }
      label {
        display: inherit;
      }
    }
  }
}
button {
  background: $bg-color1;
  outline: none;
  border: none;
  color: white;
  padding: 5px 10px;
  cursor: pointer;
  &:active,
  &:hover {
    filter: contrast(130%);
  }
  &:disabled {
    background: grey;
    &:hover {
      filter: inherit;
      cursor: not-allowed;
    }
  }
}

p {
  font-size: 1.1rem;
  line-height: 1.3rem;
  margin: 0;
  margin-bottom: 20px;
  font-size: 1rem;
}
a {
  color: $font-color1;
  text-transform: uppercase;
  text-decoration: none;
  &:hover {
    font-weight: bold;
  }
}

h1,
h2 {
  color: $font-color1 !important;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  margin-bottom: 15px;
}

h1 {
  font-size: 1.3rem;
}
h2 {
  font-size: 1.1rem;
}

hr {
  width: 100px !important;
  margin-left: 0;
  margin-top: 20px;
  margin-bottom: 20px;
  background: grey;
  height: 3px;
  border: 0;
}
// Subnavigation
.sub-nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  a {
    margin: 2px 0;
    font-size: 0.9rem;
    cursor: pointer;
    transition: font-weight 0.2s;
    &:hover {
      font-weight: 600;
    }
    &.router-link-exact-active {
      font-weight: bold;
    }
  }
}
@media (min-width: 768px) {
  .sub-nav {
    align-items: flex-end;
  }
}
// Cluster Farbe
.marker-cluster {
  background-color: #093e7f8f !important;
  div {
    background-color: #093e7fa9 !important;
    span {
      color: white;
      font-size: 1rem;
    }
  }
}
.leaflet-control-attribution {
  a {
    text-transform: inherit;
    font-size: 0.8rem;
    &:hover {
      font-weight: inherit;
    }
  }
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter {
  opacity: 0;
}
</style>
